import React, { useRef } from 'react';
import SEO from '../../common/SEO';
import HeaderTwo from '../../common/header/HeaderTwo';
import BannerOne from '../../components/banner/BannerOne';
import NewsLetterOne from '../../components/newsletter/NewsLetterOne';
import FooterOne from '../../common/footer/FooterOne';
import HomeOneContactUs from '../../components/home-one/HomeOneContactUs';
import HomeOneAIRecommendations from '../../components/home-may2025/HomeOneAIRecommendations';
import { useLocation } from 'react-router-dom';
import { scrollToViewFromTop } from '../../utils/scrollToViewFromTop';
import LogoTwo from '../../components/logos/LogoTwo';
import CoreOfferings from '../../components/home-may2025/CoreOfferings';
import Stats from '../../components/home-may2025/Stats';
import HomeAppliedAISolutions from '../../components/home-may2025/HomeAppliedAISolutions';
import HomeEdgeAIProductSuite from '../../components/home-may2025/HomeEdgeAIProductSuite';
import HomeIndustriesWeServe from '../../components/home-may2025/HomeIndustriesWeServe';
import HomeIndustryAlignedUpskilling from '../../components/home-may2025/HomeIndustryAlignedUpskilling';
import HomeAIResearchInnovation from '../../components/home-may2025/HomeAIResearchInnovation';
import TestimonialTwo from '../../components/testimonial/TestimonialTwo';
import HomeFooter from '../../components/home-may2025/HomeFooter';

const HomeMay2025 = () => {

  const GoogleReviews = useRef();

  const location = useLocation();
  if(location.hash) {
    const sectionId = location.hash.slice(1);
    console.log(sectionId);
    scrollToViewFromTop(sectionId);
  }

  return (
    <>
      <SEO
        title="M2M Tech"
        description="Unlock the potential of your enterprise by envisioning new possibilities with our innovative AI solutions tailored for your business needs."
      />

      <HeaderTwo styles="header-transparent header-style-2" searchDisable />

      <BannerOne
        GoogleReviews={GoogleReviews}
      />
      <LogoTwo />
      <HomeOneAIRecommendations />
      <CoreOfferings />
      <Stats />
      <HomeAppliedAISolutions />
      <HomeEdgeAIProductSuite />
      <HomeIndustriesWeServe />
      <HomeIndustryAlignedUpskilling />
      <HomeAIResearchInnovation />
      <TestimonialTwo />
      <HomeFooter />
      {/* <HomeOneContactUs /> */}
      <NewsLetterOne />
      <FooterOne />
    </>
  )
}

export default HomeMay2025;